export default "__VITE_ASSET__DmP4tqIe__"